// includes/js-src/janus-engine/pl/refusal.ts — the one error class the PL calculation raises when the browser cannot
// legitimately price (a definition it cannot see, a pricing input it has no source for). calcPl turns it into
// `{ unsupported: token }`; anything else that throws is `{ error }`. Plan D7, §6.2.
export class PlRefusal extends Error {
    constructor(readonly token: string) { super(token); }
}
